(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9636],{

/***/ 73777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90359);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50866);
/* harmony import */ var _components_Training_Training__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1584);
/* harmony import */ var _components_UnaccessibleErrorForGuest_InaccessibleErrorForGuest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63102);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31955);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40238);
/* harmony import */ var _interfaces_Calendar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17923);
/* harmony import */ var _services_calendar_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Trainings = function Trainings(props) {
  var _props$training, _props$training$cours, _props$training$cours2, _props$training2, _props$training2$cour, _props$training2$cour2, _props$training3, _props$training3$cour, _props$training4, _props$training4$cour;

  if (props.status === 401 && props.isGuest) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_UnaccessibleErrorForGuest_InaccessibleErrorForGuest__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
      title: "".concat(((_props$training = props.training) === null || _props$training === void 0 ? void 0 : (_props$training$cours = _props$training.course) === null || _props$training$cours === void 0 ? void 0 : (_props$training$cours2 = _props$training$cours.seo) === null || _props$training$cours2 === void 0 ? void 0 : _props$training$cours2.title) || '', " | Studiow.cz"),
      description: (_props$training2 = props.training) === null || _props$training2 === void 0 ? void 0 : (_props$training2$cour = _props$training2.course) === null || _props$training2$cour === void 0 ? void 0 : (_props$training2$cour2 = _props$training2$cour.seo) === null || _props$training2$cour2 === void 0 ? void 0 : _props$training2$cour2.description,
      noindex: ((_props$training3 = props.training) === null || _props$training3 === void 0 ? void 0 : (_props$training3$cour = _props$training3.course) === null || _props$training3$cour === void 0 ? void 0 : _props$training3$cour.state) === _interfaces_Calendar__WEBPACK_IMPORTED_MODULE_10__/* .EventStates.NO_VISIBLE */ .WD.NO_VISIBLE || !_constants__WEBPACK_IMPORTED_MODULE_9__/* .IS_PROD */ .XK,
      nofollow: ((_props$training4 = props.training) === null || _props$training4 === void 0 ? void 0 : (_props$training4$cour = _props$training4.course) === null || _props$training4$cour === void 0 ? void 0 : _props$training4$cour.state) === _interfaces_Calendar__WEBPACK_IMPORTED_MODULE_10__/* .EventStates.NO_VISIBLE */ .WD.NO_VISIBLE || !_constants__WEBPACK_IMPORTED_MODULE_9__/* .IS_PROD */ .XK
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Training_Training__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      training: props === null || props === void 0 ? void 0 : props.training
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})]
  });
};

Trainings.getInitialProps = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
    var _ctx$res, _ctx$res$req, _ctx$res$req$cookies, _ctx$res2, _ctx$res2$req, _ctx$res2$req$cookies, token, _yield$calendarApi$ge, training, _yield$calendarApi$ge2, dates, _yield$calendarApi$ge3, lecturers, _yield$calendarApi$ge4, modules, _error$response, _error$response2, _ctx$res3, _ctx$res3$req, _ctx$res3$req$cookies;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            token = (ctx === null || ctx === void 0 ? void 0 : (_ctx$res = ctx.res) === null || _ctx$res === void 0 ? void 0 : (_ctx$res$req = _ctx$res.req) === null || _ctx$res$req === void 0 ? void 0 : (_ctx$res$req$cookies = _ctx$res$req.cookies) === null || _ctx$res$req$cookies === void 0 ? void 0 : _ctx$res$req$cookies[_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY */ .Wx]) || js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get(_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY */ .Wx) || (ctx === null || ctx === void 0 ? void 0 : (_ctx$res2 = ctx.res) === null || _ctx$res2 === void 0 ? void 0 : (_ctx$res2$req = _ctx$res2.req) === null || _ctx$res2$req === void 0 ? void 0 : (_ctx$res2$req$cookies = _ctx$res2$req.cookies) === null || _ctx$res2$req$cookies === void 0 ? void 0 : _ctx$res2$req$cookies[_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY_GUEST */ .rj]) || js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get(_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY_GUEST */ .rj);
            _context.next = 4;
            return _services_calendar_service__WEBPACK_IMPORTED_MODULE_11__/* .calendarApi.getTraining */ .w.getTraining(ctx.query.slug, token);

          case 4:
            _yield$calendarApi$ge = _context.sent;
            training = _yield$calendarApi$ge.data;
            _context.next = 8;
            return _services_calendar_service__WEBPACK_IMPORTED_MODULE_11__/* .calendarApi.getTrainingDates */ .w.getTrainingDates(ctx.query.slug, token);

          case 8:
            _yield$calendarApi$ge2 = _context.sent;
            dates = _yield$calendarApi$ge2.data;
            _context.next = 12;
            return _services_calendar_service__WEBPACK_IMPORTED_MODULE_11__/* .calendarApi.getTrainingLecturers */ .w.getTrainingLecturers(ctx.query.slug, token);

          case 12:
            _yield$calendarApi$ge3 = _context.sent;
            lecturers = _yield$calendarApi$ge3.data;
            _context.next = 16;
            return _services_calendar_service__WEBPACK_IMPORTED_MODULE_11__/* .calendarApi.getTrainingModules */ .w.getTrainingModules(ctx.query.slug, token);

          case 16:
            _yield$calendarApi$ge4 = _context.sent;
            modules = _yield$calendarApi$ge4.data;
            return _context.abrupt("return", {
              status: 200,
              training: _objectSpread(_objectSpread({}, training), {}, {
                dates: dates,
                lecturers: lecturers,
                modules: modules
              })
            });

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](0);

            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404)) {
              _context.next = 25;
              break;
            }

            return _context.abrupt("return", ctx.res.writeHead(302, {
              Location: _constants__WEBPACK_IMPORTED_MODULE_9__/* .ROUTES.NOT_FOUND */ .Z6.NOT_FOUND
            }).end());

          case 25:
            if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 401)) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", {
              status: 401,
              isGuest: (ctx === null || ctx === void 0 ? void 0 : (_ctx$res3 = ctx.res) === null || _ctx$res3 === void 0 ? void 0 : (_ctx$res3$req = _ctx$res3.req) === null || _ctx$res3$req === void 0 ? void 0 : (_ctx$res3$req$cookies = _ctx$res3$req.cookies) === null || _ctx$res3$req$cookies === void 0 ? void 0 : _ctx$res3$req$cookies[_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY_GUEST */ .rj]) || js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get(_constants__WEBPACK_IMPORTED_MODULE_9__/* .ACCESS_TOKEN_KEY_GUEST */ .rj)
            });

          case 27:
            return _context.abrupt("return", {
              status: 500
            });

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 21]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (Trainings);

/***/ }),

/***/ 40451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail-kurzu/[...slug]",
      function () {
        return __webpack_require__(73777);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,354,5675,6066,9392,684,5897,1801,505,9774,2888,179], function() { return __webpack_exec__(40451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);